import { strVal } from '../../../modules/Utils'
import React, { Component, Fragment } from 'react'
import { Alert, Button, Col, Form, Input, Row } from 'antd'

class AccountsForm extends Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
  }

  handleConfirmBlur = (e) => {
    const value = e.target.value
    this.setState({ confirmDirty: this.state.confirmDirty || !!value })
  }

  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form
    if (value && value !== form.getFieldValue('newPassword')) {
      callback('Two passwords that you enter is inconsistent!')
    } else {
      callback()
    }
  }

  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirmPassword'], { force: true })
    }
    callback()
  }

  render() {
    const formItemLayoutRow = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const { getFieldDecorator } = this.props.form
    let { user, client, submitting, submit, update } = this.props
    return (
      <Form layout="horizontal">
        {(strVal(user, 'status') === 'invited' || !user) && (
          <Fragment>
            <Row>
              <Col span={20} offset={2} style={{ marginBottom: 20 }}>
                <h3 {...formItemLayoutRow}>Create and Send Account Invitation</h3>
                {strVal(user, 'status') === 'invited' && (
                  <Alert
                    {...formItemLayoutRow}
                    message="Invitation Has been already been sent, But not accepted yet"
                    type="error"
                  />
                )}
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  label="Email ID"
                  {...formItemLayoutRow}
                  extra={
                    strVal(client, 'member.email.label')
                      ? `This Client have This email as default : ${strVal(client, 'member.email.label')}`
                      : ''
                  }>
                  {getFieldDecorator('email', {
                    initialValue: strVal(user, 'email'),
                    rules: [{ required: true, message: "Email ID can't be empty " }],
                  })(<Input placeholder="email" />)}
                </Form.Item>
              </Col>
            </Row>
          </Fragment>
        )}
        {strVal(user, 'status') === 'Active' && user && (
          <Fragment>
            <Row>
              <Col span={20} offset={2} style={{ marginBottom: 20 }}>
                <h3 {...formItemLayoutRow}>Update Admin Account For Client App</h3>
              </Col>
            </Row>
            <Row>
              <Form.Item label="Username" {...formItemLayoutRow}>
                <Input placeholder="Username" value={strVal(user, 'username')} disabled />
              </Form.Item>
            </Row>
            <Row>
              <Form.Item label="Full Name" {...formItemLayoutRow}>
                {getFieldDecorator('fullName', {
                  initialValue: strVal(user, 'fullName'),
                  rules: [{ required: true, message: "Name can't be empty " }],
                })(<Input placeholder="Name" />)}
              </Form.Item>
            </Row>
            <Row>
              <Form.Item label="Mobile No." {...formItemLayoutRow}>
                {getFieldDecorator('mobile', {
                  initialValue: strVal(user, 'mobile'),
                  rules: [{ required: true, message: "mobile can't be empty " }],
                })(<Input placeholder="Mobile" />)}
              </Form.Item>
            </Row>
            <Row>
              <Form.Item label="Phone No." {...formItemLayoutRow}>
                {getFieldDecorator('otherMobile', {
                  initialValue: strVal(user, 'otherMobile'),
                })(<Input placeholder="Phone No." />)}
              </Form.Item>
            </Row>
            <Row>
              <Form.Item label="New Password" {...formItemLayoutRow}>
                {getFieldDecorator('newPassword', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your password!',
                    },
                    {
                      validator: this.validateToNextPassword,
                    },
                  ],
                })(<Input type="password" placeholder="Password" />)}
                <Alert
                  {...formItemLayoutRow}
                  message="Don't Put anything unless you want to change the password !!"
                  type="warning"
                />
              </Form.Item>
            </Row>
            <Row>
              <Form.Item label="Confirm Password" {...formItemLayoutRow}>
                {getFieldDecorator('confirmPassword', {
                  rules: [
                    {
                      required: true,
                      message: 'Please confirm your password!',
                    },
                    {
                      validator: this.compareToFirstPassword,
                    },
                  ],
                })(<Input type="password" placeholder="Confirm Password" onBlur={this.handleConfirmBlur} />)}
              </Form.Item>
            </Row>
          </Fragment>
        )}

        <Button type="primary" loading={submitting} onClick={!user ? submit : update}>
          {!user ? 'Invite' : 'Update'}
        </Button>
      </Form>
    )
  }
}

export default Form.create()(AccountsForm)
